module.exports = __webpack_public_path__ + "static/media/elevenlabs_ai.7eb2fd4e.png";